
































import Vue from "vue";
import ViewFavorites from "./ViewFavorites.vue";
import EditFavorite from "./EditFavorite.vue";
import CreateHyperlink from "../../dialogs/CreateHyperlink.vue";
import ZenyaDialog from "../../../components/dialogs/ZenyaDialog.vue";
import { HyperlinkItem } from "@/types/HyperlinkItem";
import { SourceType } from "@/enums";

export default Vue.extend({
    name: "ManageFavorites",
    components: { ZenyaDialog, ViewFavorites, EditFavorite, CreateHyperlink },
    props: {
        value: { type: Boolean, required: true }
    },
    data: function () {
        return {
            showViewMode: true,
            currentItem: { id: 0, title: "", hyperlinkId: null },
            showCreateHyperlink: false,
            sourceType: SourceType.Favorite
        };
    },
    methods: {
        openEdit(item) {
            this.currentItem = item;
            this.showViewMode = false;
        },
        onCancel() {
            this.showViewMode = true;
        },
        openCreateHyperlink() {
            this.showCreateHyperlink = true;
        },
        closeCreateHyperlink(hyperlinkItem: HyperlinkItem) {
            if (hyperlinkItem != null) this.openEdit({ id: 0, title: hyperlinkItem.description, hyperlinkId: hyperlinkItem.id });

            this.showCreateHyperlink = false;
        }
    },
    computed: {
        isViewScreen(): boolean {
            return this.showViewMode;
        },
        isEditScreen(): boolean {
            return !this.showViewMode;
        },
        okButtonText(): string {
            if (this.isEditScreen) return this.$t("general.buttons.save").toString();

            return null;
        },
        cancelButtonText(): string {
            if (this.isEditScreen) return this.$t("general.buttons.cancel").toString();
            else if (this.isViewScreen) return this.$t("general.buttons.close").toString();

            return null;
        },
        popupTitle(): string {
            if (this.isEditScreen) return this.$t("portal.portals.favorites.editFavorite").toString();
            else if (this.isViewScreen) return this.$t("portal.portals.favorites.link").toString();

            return "";
        }
    }
});
